import React from "react";
import { Award, BookOpen, Heart, CheckCircle } from "lucide-react";
import TherapistImg from '../../img/rutika-img.jpeg'; 

const HomeAboutUs = () => {
    return (
        <section className="hob-aboutus-section">
            <div className="hob-aboutus-container">
                {/* Left Section */}
                <div className="hob-aboutus-left">
                    <h2 className="hob-aboutus-heading">About Me</h2>
                    <p className="hob-aboutus-text">
                        As a <strong>Clinical Psychologist</strong> with over 7 years of professional experience, 
                        I am deeply committed to helping individuals navigate life’s challenges with compassion, 
                        empathy, and evidence-based care. Over the course of my practice, I have had the privilege 
                        of working with children, adolescents, and adults, supporting them through a wide range 
                        of emotional, behavioral, and psychological concerns.
                        <br /><br />
                        My expertise lies in addressing complex clinical cases, where I combine a thorough understanding 
                        of psychological principles with a personalized approach tailored to each client’s unique needs. 
                        I believe in creating a safe, non-judgmental, and supportive space where individuals can explore 
                        their thoughts and emotions, build resilience, and move toward meaningful growth and healing.
                    </p>
                </div>

                {/* Right Section */}
                <div className="hob-aboutus-right">
                    <div className="hob-aboutus-image-wrapper">
                        <img
                            src={TherapistImg}
                            alt="Therapist"
                            className="hob-aboutus-image"
                        />

                        <div className="hob-aboutus-float hob-aboutus-top-right">
                            <div className="hob-aboutus-flex">
                                <Award size={18} />
                                <span>7+ Years</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Experienced Clinical Psychologist
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-bottom-right">
                            <div className="hob-aboutus-flex">
                                <Heart size={18} />
                                <span>100+ Lives Impacted</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Helping clients build resilience and healing
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-center-float">
                            <div className="hob-aboutus-flex">
                                <BookOpen size={18} />
                                <span>Blogs & Insights</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Sharing knowledge for awareness and growth
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAboutUs;
